import React, {useState} from "react";
import styled from "styled-components";
import Calendar from "../molecules/Calendar";
import chk_on from '../../assets/images/icon_chk_on.png';
import Btn from "../atoms/Btn";
import {device} from "../../assets/styles/media.js";
import Input from "../atoms/Input";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons";
import Radio from "../atoms/Radio";
import request from "../../config/Axios";

const FormContainer = styled.div`
    box-sizing: border-box;
`;
const Form = styled.form``;
const FieldSet = styled.fieldset`
    display: flex;
    flex-direction: column;
`;
const Legend = styled.legend`
    display: none;
`;
const InputBox = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    position: relative;
`;
const Label = styled.label`
    color: #30343a;
    padding-left: 5px;
    font-size: 15px;
    padding-bottom: 5px;

    ${device.tablet} {
        font-size: 15px;
    }
    ${device.mobile} {
        font-size: 13px;
    }
`;
const Required = styled.span`
    font-size: 12px;
    color: #ff7171;
    margin-left: 1px;

    ${device.mobile} {
        font-size: 12px;
    }
`;
const TimeSelect = styled.select`
    box-sizing: border-box;
    border: none;
    background-color: rgba(238, 238, 238, 0.5);
    padding: 9px 20px;
    list-style: none;
    height: 45px;
    color: #bababa;
    font-size: 14px;
    cursor: pointer;
    appearance: none;
`;

const MoreBtn = styled(FontAwesomeIcon)`
    width: 15px;
    height: 15px;
    position: absolute;
    top: 35px;
    right: 12px;
`;

const Option = styled.option`
color: #232121;
`;
const RadioGroup = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 17px;
    margin-top: 5px;
   
    label:first-child {
        width: 180px;
    }

    label:last-child {
        margin-left: 20px;
    }

    ${device.mobile} {
        label:first-child {
            width: 140px;
        }
    }
`;
const ChoiceBox = styled.div`
    margin-top: 15px;
    text-align: center;

    span {
        color: #454545;
        font-size: 15px;
        margin-right: 15px;
    }

    ${device.tablet} {
        font-size: 14px;
    }

    ${device.mobile} {
        span {
            font-size: 13px;
        }
    }
`;
const CheckBox = styled.input`
    display: none;`;
const CheckboxLabel = styled.label`
    color: #30343a;
    font-size: 14px;

    &::before {
        content: "";
        display: inline-block;
        border: 1px solid #d8d8d8;
        width: 18px;
        height: 18px;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 6px;
    }

    input:checked + &::before {
        background: url(${chk_on}) no-repeat center center;
        background-size: cover;
        border: 1px solid #fff;
    }

    ${device.mobile} {
        font-size: 13px;
       
    }
}`;

const PrivacyBox = styled.div`
    box-sizing: border-box;
    max-width: 450px;
    max-height: 150px;
    padding: 9px 10px 10px;
    border: 1px solid #d2d2d2;
    overflow-y: scroll;
    color: #999;

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        background-clip: padding-box;
        border: 3px solid transparent;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    ${device.tablet} {
        max-width: 100vw;
        width: 100%;

    }
 
`;
const PTitle = styled.p`
    margin-bottom: 15px;
    font-size: 13px;
    
    ${device.tablet} {
        font-size: 14px;
    }
    
`;
const PrivacyList = styled.ul``;
const PrivacyItem = styled.li`
    margin-top: 10px;
    line-height: 18px;
    font-size: 13px;
    p {
        font-size: 13px;
    }

    ${device.tablet} {
        font-size: 13px;
        p {
            font-size: 13px;
        }
    }
`;


const ReservationModal = ({setOpenModal}) => {
        const timeList = ["희망시간을 선택해주세요", "11:00", "13:00", "15:00", "단체예약(담당자 유선 연락 후 일정 조율)"]
        const [selectedDate, setSelectedDate] = useState("");
        const [selectedTime, setSelectedTime] = useState("");

        const [agree, setAgree] = useState(false);
        const [tour, setTour] = useState(true);
        const initReserveInfo = {
            company: "",
            username: "",
            tel: "",
            email: "",
            date:  "",
            time: "",
            reserveCount: "",
            tour: tour, //전시해설
            agree:agree
        };
        const [reserveInfo, setReserveInfo] = useState(initReserveInfo);

        const onChangeReserveInfo = (e) => {
            const {name, value} = e.target;

            setReserveInfo((prevState) => ({
                    ...prevState,
                    [name]: value
                })
            )
        };
        const handleTourChange = (e) => {
            setTour(e.target.value === "true");
        };

    function getPostposition(word, josa1 = "을", josa2 = "를") {
        const lastChar = word[word.length - 1];
        const uni = lastChar.charCodeAt(0);
        const hasFinalConsonant = (uni - 44032) % 28 !== 0;
        return word + (hasFinalConsonant ? josa1 : josa2);
    }

        const checkValue = (refinedData) => {
            let flag = true;

            const checkItems = {
                company : "단체 또는 회사명",
                username : "예약자명",
                tel : "연락처",
                email : "이메일",
                date : "예약일자",
                time : "희망시간",
                reserveCount : "예약인원",
            };

            for (const data of Object.keys(checkItems)) {
                if (flag === true && refinedData[data] === "") {
                    alert(`${getPostposition(checkItems[data])} 입력해주세요.`);
                    return;
                }
            }
            const isValidEmail = (email) => {
                const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                return emailRegex.test(email);
            };

            if (!isValidEmail(refinedData.email)) {
                alert("정확한 이메일을 입력하세요.");
                return;
            }

            if (refinedData.reserveCount <= 0) {
                alert("정확한 예약인원 입력하세요.");
                return;
            }

            if (refinedData.agree === false) {
                alert("개인정보 수집 및 이용에 동의해주세요.");
                return;
            }


            return refinedData;

        }

        const sendEmail = async () => {
            const refinedReserveInfo = {
                ...reserveInfo,
                date: selectedDate,
                time: selectedTime,
                agree:agree,
                tour : tour ? "Y" :"N"
            };
            const checkedData = checkValue(refinedReserveInfo);

            if (checkedData !== undefined) {
                try {
                 const res = await request.post(`reservation`, {...refinedReserveInfo});
                     if(res.status===200) {
                         window.alert("신청되었습니다.");
                         setOpenModal(false);
                     }
                } catch (error) {
                    window.alert("신청에 실패하였습니다.")
                }
            }
        };


        return (
            <FormContainer>
                <Form>
                    <FieldSet>
                        <Legend>투어 및 단체 예약 입력</Legend>
                        <Input
                            name="company"
                            label='단체 또는 회사명'
                            type="text"
                            onChange={onChangeReserveInfo}
                            placeholder="단체 또는 회사명을 입력해주세요"/>

                        <Input
                            name="username"
                            label='예약자명'
                            type="text"
                            onChange={onChangeReserveInfo}
                            placeholder="예약자명을 입력해주세요"/>

                        <Input
                            name="tel"
                            label="연락처"
                            type="text"
                            onChange={onChangeReserveInfo}
                            placeholder="ex) 01012345678"/>

                        <Input
                            name="email"
                            label="이메일"
                            type="text"
                            onChange={onChangeReserveInfo}
                            placeholder="ex) dforest@gmail.co.kr"/>

                        <InputBox>
                            <Label htmlFor="date">예약일자<Required>*</Required></Label>
                            <Calendar
                                selectedDate={selectedDate}
                                setSelectedDate={setSelectedDate}
                            />
                        </InputBox>

                        <InputBox>
                            <Label>희망시간<Required>*</Required></Label>
                            <TimeSelect
                                value={selectedTime}
                                onChange={(e) => setSelectedTime(e.target.value)}
                            >
                                {timeList.map((item, index) => (
                                        <Option key={index}>
                                            {item}
                                        </Option>
                                    )
                                )}
                            </TimeSelect>
                            <MoreBtn icon={faCaretDown} size={"xs"} style={{color: "#f5ab18"}}/>
                        </InputBox>

                        <Input
                            name="reserveCount"
                            label="예약인원(명)"
                            type="number"
                            onChange={onChangeReserveInfo}
                            placeholder="ex) 10"/>

                        <RadioGroup>
                            <Label>투어신청(전시해설)</Label>
                            <Radio type="radio"
                                   value={true}
                                   checked={tour}
                                   onChange={handleTourChange}
                                   id="yes-tour"
                                   text={"신청"}
                            />

                            <Radio type="radio"
                                   value={false}
                                   checked={!tour}
                                   onChange={handleTourChange}
                                   id="no-tour"
                                   text={"미신청"}
                            />
                        </RadioGroup>

                        {/* 개인정보 수집 동의 */}
                        <PrivacyBox>
                            <PrivacyList>
                                <PTitle>개인정보 수집 및 이용 동의안내</PTitle>

                                <PrivacyItem>
                                    <p>개인정보의 수집ㆍ이용 목적</p>
                                    <p>- 강아지숲 단체예약을 위한 편의 제공</p>
                                </PrivacyItem>

                                <PrivacyItem>
                                    <p>수집하는 개인정보의 항목</p>
                                    <p>- 단체명 또는 회사명, 성명(예약자명), 연락처(휴대전화), 이메일</p>
                                </PrivacyItem>

                                <PrivacyItem>
                                    <p>수집하는 개인정보의 항목</p>
                                    <p>- 단체예약 진행(발권 기준) 종료후 7일 이내 파기</p>
                                </PrivacyItem>

                                <PrivacyItem>
                                    강아지숲에서 행하는 개인정보의 수집 및 이용에 동의하지 않으실 수 있습니다.
                                    <p>(단, 동의하지 않을 시에는 단체예약 신청이 불가합니다.)</p>
                                </PrivacyItem>

                            </PrivacyList>
                        </PrivacyBox>
                        <ChoiceBox>
                            <span>개인정보 수집 및 이용에 동의하십니까?</span>
                            <CheckBox type="checkbox"
                                      id="agree"
                                      checked={agree}
                                      onChange={() => {
                                          setAgree(!agree)
                                      }}/>
                            <CheckboxLabel htmlFor="agree">동의</CheckboxLabel>
                        </ChoiceBox>

                    </FieldSet>
                </Form>
                <Btn text="신청하기" onClick={sendEmail} mt={50} />
            </FormContainer>
        );
    }
;

export default ReservationModal;
